import { Navigate, useLocation } from "react-router-dom";

import { Card, Text } from "@tremor/react";

import { usePermissions } from "@/providers/PermissionsProvider";

/**
 * Destino das rotas antigas `/users` e `/users/:id`.
 *
 * O admin da empresa cai na própria empresa (e, se havia um id, no detalhe daquele usuário). A
 * Freeler não tem como saber a empresa só pelo id do usuário, então vai para a lista de empresas:
 * a gestão de usuários passou a viver dentro do detalhe de cada uma.
 */
const LegacyUsersRedirect = () => {
  const { userRole, isLoading } = usePermissions();
  const { pathname } = useLocation();

  // Em branco o operador não saberia se a página quebrou: enquanto as permissões carregam, avisa.
  if (isLoading) {
    return (
      <Card className="mx-auto" aria-busy="true">
        <Text>Redirecionando…</Text>
      </Card>
    );
  }

  if (userRole === "EXTERNAL_BACKOFFICE") {
    const userId = pathname.split("/").filter(Boolean).at(1);
    return (
      <Navigate to={userId ? `/my-company/users/${userId}` : "/my-company?tab=users"} replace />
    );
  }

  return <Navigate to="/companies?status=ACTIVE" replace />;
};

export default LegacyUsersRedirect;
